import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import facilities from './modules/facilities'
import advertisements from './modules/advertisements'
import publicitygroups from './modules/publicitygroups'
import statistics from './modules/statistics'

Vue.use(Vuex)

export const store = new Vuex.Store({
	// this state is temporary! TODO: fill in after login!
	state: {
		// publicitycustomer ID
		pid: '',
		// publicitycustomer name
		cname: '',
		// publicitycustomer identifier
		cid: '',
		// system status
		sys_stat_database: 'OK',
		sys_stat_api: 'OK',
		sys_stat_internet: 'OK',
	},
	mutations: {

	},
	getters: {

	},
	actions: {

	},
	modules: {
		facilities,
		advertisements,
		publicitygroups,
		statistics,
		auth
	}
})
